import { Component, OnDestroy } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet } from '@angular/router';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { ToasterService } from './core/services/toaster/toaster.service';
import { ToasterComponent } from './core/component/toaster/toaster.component';
import { BackgroundService } from './core/services/background-service/background.service';
import { AuthService } from './core/services/auth.service';
import { NotificationServiceService } from './core/services/notification/notification-service.service';
import { VersioncheckService } from './core/services/version-check/versioncheck.service';

@Component({
  selector: 'app-root',
  imports: [
    StoreModule,
    CommonModule,
    RouterOutlet,
    NgbToastModule,
    ToasterComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [ToasterService],
})
export class AppComponent {
  routerReady = false;
  

    
  constructor(private notificationService: NotificationServiceService,
    public versionCheck:VersioncheckService,public refreshTokenService:BackgroundService
  ) 
  {    
    this.versionCheck.startVersionChecking(); 
    this.refreshTokenService.startTask()
  }
  ngOnInit() {
    this.notificationService.requestPermission(); 
  }
  
}

